export default __webpack_public_path__ + "media/images/features/ambassador/ogp-dc7c6968852ba000bdcc479c4ae5aacc.jpg";